import React, { useEffect, useState } from 'react'
import { defaults } from './detailsPageComponents'

export default function Wizard({ containerClass, defaultPageIndex, pages, bottomNavButtons = true, ...props }) {
  const footerButtons = defaults.wizard?.footerButtons || []
  const [currentPage, setCurrentPage] = useState(defaultPageIndex ?? 0)
  const filteredPages = Array.isArray(pages) ? pages.filter(page => !page.hidden) : []
  const lastEnabledIdx = filteredPages.findLastIndex(page => !page.navDisabled)
  const maxClickableIdx = lastEnabledIdx >= 0 ? lastEnabledIdx : currentPage

  useEffect(() => {
    if (filteredPages.length > 0 && currentPage > filteredPages.length - 1) setCurrentPage(filteredPages.length - 1)
  }, [filteredPages.length, currentPage])

  function nextPage() {
    for (let i = currentPage + 1; i < filteredPages.length; i++) {
      if (!filteredPages[i].navDisabled) return setCurrentPage(i)
    }
  }
  function prevPage() {
    for (let i = currentPage - 1; i >= 0; i--) {
      if (!filteredPages[i].navDisabled) return setCurrentPage(i)
    }
  }

  useEffect(() => {
    if (filteredPages?.length < currentPage) setCurrentPage(0)
  }, [filteredPages?.length, currentPage])
  if (!filteredPages.length) return null

  function wrapContent(content, i) {
    return <div key={i} className={`schema-form__wizard-content${currentPage === i ? ' selected' : ''}`}>{content}</div>
  }

  return <div className={containerClass}>
    <div className='schema-form__wizard-nav'>
      {filteredPages.map((page, i) => (
        <div key={i}
          className={`schema-form__wizard-item${currentPage === i ? ' selected' : ''}${page.navDisabled ? ' disabled ' : ''}`}
          onClick={() => !page.navDisabled && setCurrentPage(i)}
        >
          {page.title}
        </div>
      ))}
    </div>
    {filteredPages.map((page, i) => {
      if (typeof page?.component === 'function') return wrapContent(page.component({ goToPage: setCurrentPage, nextPage, prevPage }), i)
      else if (page?.component?.$$typeof === Symbol.for('react.element')) return wrapContent(page.component, i)
      else return wrapContent('Unknown page type', i)
    })}
    {bottomNavButtons
      ? <>
        <div className='schema-form__wizard-bottom-nav'>
          <div className='schema-form__wizard-bottom-nav-count'>
            <span className='schema-form__wizard-bottom-nav-count__current'>{currentPage + 1}</span> / {filteredPages.length}
          </div>
          <div className='schema-form__wizard-bottom-nav-title'>
            <span>{filteredPages[currentPage]?.title}</span>
          </div>
          <div className='schema-form__wizard-bottom-nav-buttons'>
            {
              footerButtons.map(button => button({ nextPage, prevPage, currentPage, maxClickableIdx }))
            }
          </div>
        </div>
      </>
      : null}
  </div>
}
